import { all, fork, takeLatest, takeLeading } from 'redux-saga/effects';
import { sliceName } from '../redux/userSlice';
import * as Sagas from './saga';

function* watchFetchMyUser() {
    yield takeLeading(`${sliceName}/fetchMyUser`, Sagas.fetchMyUserSaga);
}

function* watchFetchCompanyBaseUsers() {
    yield takeLeading(
        `${sliceName}/fetchCompanyBaseUsers`,
        Sagas.fetchCompanyBaseUsersSaga
    );
}

function* watchUpdateLanguage() {
    yield takeLatest(`${sliceName}/updateLanguage`, Sagas.updateLanguageSaga);
}

function* watchPostConnectUserGmail() {
    yield takeLatest(
        `${sliceName}/postConnectUserGmail`,
        Sagas.postConnectUserGmailSaga
    );
}

function* watchPostConnectUserOutlook() {
    yield takeLatest(
        `${sliceName}/postConnectUserOutlook`,
        Sagas.postConnectUserOutlookSaga
    );
}

function* watchDeleteUserMailbox() {
    yield takeLatest(
        `${sliceName}/deleteUserMailbox`,
        Sagas.deleteUserMailboxSaga
    );
}

export function* userSagas() {
    yield all([
        fork(watchFetchMyUser),
        fork(watchFetchCompanyBaseUsers),
        fork(watchUpdateLanguage),
        fork(watchPostConnectUserGmail),
        fork(watchPostConnectUserOutlook),
        fork(watchDeleteUserMailbox),
    ]);
}
